<template>
  <v-container>
    <v-app-bar
      app
      flat
      color="primary"
      style="z-index: 1999"
      dark
      class="pa-0 ma-0 subtitle-2"
    >
      <v-btn
        text
        color="white"
        small
        outlined
        fab
        class="mr-3"
        @click="showGoBack = true"
      >
        <v-icon>mdi-arrow-left-bold</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="mr-12">
        {{ $store.state.storeClient.client.basicSettings.fullName }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <main-sub-page-toolbar icon="mdi-plus-box-multiple">
              {{ $t("dashboardCardUserNewOrderTitle") }}
              {{ printStepperStepTitle }}
            </main-sub-page-toolbar>
          </v-flex>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <v-stepper
              class="#505050--text mb-12"
              :class="
                getTheme() == 'dark'
                  ? 'outlined elevation-0'
                  : 'flat elevation-0'
              "
              :style="
                getTheme() == 'dark'
                  ? 'border: 1px solid darkgray; background-color: whitesmoke'
                  : 'border: none; background-color: white'
              "
              v-model="e1"
            >
              <v-stepper-header class="elevation-0">
                <v-stepper-step step="1">{{ $t("lmStep") }} 1</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="2">{{ $t("lmStep") }} 2</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="3">{{ $t("lmStep") }} 3</v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <!-- IZBOR KATEGORIJE -->
                <v-stepper-content step="1" class="pa-0 mt-0 animated fadeIn">
                  <v-container fluid class="py-0">
                    <v-layout row class="px-1">
                      <v-flex
                        v-for="(item, index) in $store.state.storeGiftCategory
                          .giftCategory"
                        :key="index"
                        :id="item.id"
                        xs12
                        sm6
                        md4
                        lg3
                        xl2
                      >
                        <v-card
                          class="mx-1 mb-2 animated fadeInUpBig"
                          outlined
                          style="background-color: #fcfcfc"
                          @click="stepItUp(item)"
                        >
                          <v-card-title
                            class="
                              primary
                              white--text
                              justify-center
                              subtitle-2
                              ma-0
                              py-1
                            "
                            >{{ item.name }}</v-card-title
                          >
                          <v-card-text class="pa-0">
                            <v-img
                              :src="item.image"
                              class="hover-item d-flex align-end"
                            >
                              <div
                                v-if="desc && item.description.length > 0"
                                style="background: rgba(0, 0, 0, 0.4)"
                                class="pa-2 py-1 white--text"
                              >
                                {{ item.description }}
                              </div>
                            </v-img>
                            <v-btn
                              v-if="item.description.length > 0"
                              fab
                              absolute
                              top
                              right
                              x-small
                              color="accent"
                              style="margin-top: 25px; margin-right: -8px"
                              class="elevation-0"
                              @click="desc = !desc"
                              @click.stop
                            >
                              <v-icon medium color="white"
                                >mdi-information-variant</v-icon
                              >
                            </v-btn>
                            <!-- izpis popusta, če obstaja -->
                            <v-btn
                              v-if="item.discount"
                              absolute
                              bottom
                              right
                              small
                              style="
                                background-color: #cc0000;
                                border-radius: 8px;
                                color: white;
                              "
                              class="elevation-0"
                              @click.stop
                            >
                              {{ $t("userNewOrderSummary5aTitle") }}
                              {{ item.discount.promoCode }}
                              <span v-if="item.discount.discountType == 'Pct'"
                                >-{{ item.discount.discount }}%</span
                              >
                              <span
                                v-else-if="item.discount.discountType == 'Amt'"
                                >-{{ price(item.discount.discount) }}</span
                              >
                            </v-btn>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-stepper-content>
                <!-- IZBOR IZDELKA -->
                <v-stepper-content step="2" class="pa-0 mt-0 animated fadeIn">
                  <v-container fluid class="py-0">
                    <v-layout row class="px-1">
                      <v-flex
                        v-for="(item, index) in $store.state.storeGift.giftCat"
                        :key="index"
                        :id="item.id"
                        xs12
                        sm6
                        md4
                        lg3
                        xl2
                      >
                        <v-card
                          outlined
                          class="mx-1 mb-2 animated fadeInUpBig"
                          style="background-color: #fcfcfc"
                          @click="checkSmallDevicesLimitation(item)"
                        >
                          <v-card-title
                            class="
                              primary
                              white--text
                              justify-center
                              subtitle-2
                              ma-0
                              py-1
                            "
                            >{{ item.name }}</v-card-title
                          >
                          <v-card-text class="pa-0">
                            <v-img
                              :src="item.image"
                              class="hover-item d-flex align-end"
                            >
                              <div
                                v-if="desc && item.description.length > 0"
                                style="background: rgba(0, 0, 0, 0.4)"
                                class="pa-2 py-1 white--text"
                              >
                                {{ item.description }}
                              </div>
                            </v-img>
                            <v-btn
                              v-if="
                                item.enableSmallDevices == false &&
                                ($store.state.os == 'iOS' ||
                                  $store.state.os == 'Android')
                              "
                              fab
                              absolute
                              top
                              left
                              x-small
                              color="accent"
                              style="margin-top: 25px; margin-right: -8px"
                              class="elevation-0"
                              disabled
                              @click.stop
                            >
                              <v-img
                                :src="noSmartphonesIcon"
                                style="width: 30px; height: 30px"
                                class="hover-item d-flex align-end"
                              ></v-img>
                            </v-btn>
                            <v-btn
                              v-if="item.description.length > 0"
                              fab
                              absolute
                              top
                              right
                              x-small
                              color="accent"
                              style="margin-top: 25px; margin-right: -8px"
                              class="elevation-0"
                              @click="desc = !desc"
                              @click.stop
                            >
                              <v-icon medium color="white"
                                >mdi-information-variant</v-icon
                              >
                            </v-btn>
                            <v-btn
                              v-if="item.discount"
                              absolute
                              bottom
                              right
                              small
                              style="
                                margin-bottom: 20px;
                                margin-right: -8px;
                                background-color: #cc0000;
                                border-radius: 8px;
                                color: white;
                              "
                              class="elevation-0"
                              @click.stop
                            >
                              <span v-if="item.discount.subItem.length == 0">
                                {{ $t("userNewOrderSummary5aTitle") }}
                                {{ item.discount.promoCode }}
                                <span v-if="item.discount.discountType == 'Pct'"
                                  >-{{ item.discount.discount }}%</span
                                >
                                <span
                                  v-else-if="
                                    item.discount.discountType == 'Amt'
                                  "
                                  >-{{ price(item.discount.discount) }}</span
                                >
                              </span>
                              <span v-else>
                                <v-icon small class="white--text"
                                  >mdi-sale</v-icon
                                >
                              </span>
                            </v-btn>
                            <div
                              v-if="item.typeArray.length == 0"
                              class="subtitle-1 d-flex justify-center"
                              style="background-color: #666666; color: white"
                            >
                              {{ price(item.price) }}
                              <span class="ml-1" v-show="item.minOrder > 1">
                                ({{
                                  $t("settingsPhotoGiftMinOrderShortTitle")
                                }}
                                {{ item.minOrder }} {{ $t("lmPcs") }})</span
                              >
                            </div>
                            <div
                              v-else
                              class="subtitle-1 d-flex justify-center"
                              style="background-color: #666666; color: white"
                            >
                              {{ getPrices(item.typeArray) }}
                              <span class="ml-1" v-show="item.minOrder > 1">
                                ({{
                                  $t("settingsPhotoGiftMinOrderShortTitle")
                                }}
                                {{ item.minOrder }} {{ $t("lmPcs") }})</span
                              >
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-stepper-content>
                <!-- IZBOR PREDLOGE -->
                <v-stepper-content step="3" class="pa-0 mt-0 animated fadeIn">
                  <v-container
                    fluid
                    class="py-0"
                    v-if="selectedRoute == 'MULTIPLE-CANVAS-MULTIPLE-TEMPLATES'"
                  >
                    <v-layout row class="px-1">
                      <v-flex
                        v-for="(item, index) in canvasTemplates"
                        :key="index"
                        :id="item.id"
                        xs12
                        sm6
                        md4
                        lg3
                        xl2
                      >
                        <!-- ČE JE SAMO EN TEMPLATE-->
                        <v-card
                          outlined
                          class="mx-1 mb-2 animated fadeInUpBig"
                          style="background-color: #fcfcfc"
                          v-if="Object.keys(item.selected).length !== 0"
                        >
                          <v-card-title
                            class="
                              primary
                              white--text
                              justify-center
                              subtitle-2
                              ma-0
                              py-1
                            "
                            >{{ item.title }}</v-card-title
                          >
                          <v-card-title
                            class="
                              secondary
                              white--text
                              justify-center
                              subtitle-2
                              ma-0
                              py-1
                            "
                            >{{ item.selected.title }}</v-card-title
                          >
                          <v-card-text class="pa-0">
                            <v-img
                              contain
                              v-if="item.selected.allowAutoPreview"
                              :src="item.selected.imagePr"
                              class="hover-item d-flex align-end ma-1"
                              style="
                                max-height: 133px;
                                background-color: silver;
                              "
                            >
                              <div
                                v-if="
                                  desc && item.selected.description.length > 0
                                "
                                style="background: rgba(0, 0, 0, 0.4)"
                                class="pa-2 py-1 white--text"
                              >
                                {{ item.selected.description }}
                              </div>
                            </v-img>
                            <v-img
                              v-else
                              :src="item.selected.previewImage"
                              class="hover-item d-flex align-end"
                            >
                              <div
                                v-if="
                                  desc && item.selected.description.length > 0
                                "
                                style="background: rgba(0, 0, 0, 0.4)"
                                class="pa-2 py-1 white--text"
                              >
                                {{ item.selected.description }}
                              </div>
                            </v-img>
                            <v-btn
                              v-if="item.selected.description.length > 0"
                              fab
                              absolute
                              top
                              right
                              x-small
                              color="accent"
                              style="margin-top: 25px; margin-right: -8px"
                              class="elevation-0"
                              @click="desc = !desc"
                              @click.stop
                            >
                              <v-icon medium color="white"
                                >mdi-information-variant</v-icon
                              >
                            </v-btn>
                          </v-card-text>
                        </v-card>
                        <!-- ČE JE MOŽNOST IZBIRE TEMPLATA -->
                        <v-card
                          outlined
                          class="mx-1 mb-2 animated fadeInUpBig"
                          style="background-color: #fcfcfc"
                          v-else
                        >
                          <v-card-title
                            class="
                              primary
                              white--text
                              justify-center
                              subtitle-2
                              ma-0
                              py-1
                            "
                            >{{ item.title }}</v-card-title
                          >
                          <v-card-title class="justify-center subtitle-2">
                            <v-btn
                              medium
                              color="accent"
                              class="elevation-0"
                              @click="serveTemplateSelection(3, index)"
                            >
                              <v-icon medium color="white" class="mr-1"
                                >mdi-view-list</v-icon
                              >
                              {{ $t("fabricSelectTemplateDialogTitle") }}
                            </v-btn>
                          </v-card-title>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                  <v-container fluid class="py-0" v-else>
                    <v-layout
                      row
                      class="mx-1 mb-2"
                      v-if="subCategorys.length > 0"
                    >
                      <v-btn
                        class="mx-1 mb-1 elevation-0"
                        :text="currentTag != ''"
                        :outlined="currentTag != ''"
                        small
                        rounded
                        color="accent"
                        @click="getSubcategory('')"
                        >{{ $t("msgShowAll") }}</v-btn
                      >
                      <div v-for="(i, ind) in subCategorys" :key="ind">
                        <v-btn
                          class="mx-1 mb-1 elevation-0"
                          :text="currentTag != i"
                          :outlined="currentTag != i"
                          small
                          rounded
                          color="accent"
                          @click="getSubcategory(i)"
                          >{{ i }}</v-btn
                        >
                      </div>
                    </v-layout>
                    <v-layout row class="px-1">
                      <v-flex
                        v-for="(item, index) in $store.state.storeImageTemplate
                          .imageFilteredTemplate"
                        :key="index"
                        :id="item.id"
                        xs12
                        sm6
                        md4
                        lg3
                        xl2
                      >
                        <v-card
                          outlined
                          class="mx-1 mb-2 animated fadeInUpBig"
                          style="background-color: #fcfcfc"
                          @click="stepItUp(item)"
                        >
                          <!--<v-card-title
                            class="primary white--text justify-center subtitle-2 ma-0 py-1"
                          >{{ itemCategory }}</v-card-title>-->
                          <v-card-title
                            class="
                              primary
                              white--text
                              justify-center
                              subtitle-2
                              ma-0
                              py-1
                            "
                            >{{ item.title }}</v-card-title
                          >
                          <v-card-text class="pa-0">
                            <v-img
                              contain
                              v-if="item.allowAutoPreview"
                              :src="item.imagePr"
                              class="hover-item d-flex align-end ma-1"
                              style="
                                max-height: 133px;
                                background-color: silver;
                              "
                            >
                              <div
                                v-if="desc && item.description.length > 0"
                                style="background: rgba(0, 0, 0, 0.4)"
                                class="pa-2 py-1 white--text"
                              >
                                {{ item.description }}
                              </div>
                            </v-img>
                            <v-img
                              v-else
                              :src="item.previewImage"
                              class="hover-item d-flex align-end"
                            >
                              <div
                                v-if="desc && item.description.length > 0"
                                style="background: rgba(0, 0, 0, 0.4)"
                                class="pa-2 py-1 white--text"
                              >
                                {{ item.description }}
                              </div>
                            </v-img>
                            <v-btn
                              v-if="item.description.length > 0"
                              fab
                              absolute
                              top
                              right
                              x-small
                              color="accent"
                              style="margin-top: 25px; margin-right: -8px"
                              class="elevation-0"
                              @click="desc = !desc"
                              @click.stop
                            >
                              <v-icon medium color="white"
                                >mdi-information-variant</v-icon
                              >
                            </v-btn>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                      <v-flex
                        v-if="currentPage < currentPages"
                        xs12
                        sm6
                        md4
                        lg3
                        xl2
                      >
                        <v-btn
                          x-large
                          text
                          color="accent"
                          class="mx-1 elevation-0"
                          @click="getTemplatePages(1)"
                        >
                          <v-icon x-large class="mr-1">mdi-chevron-right</v-icon
                          >{{ $t("msgMore") }}
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-flex>

          <!-- TEMPLATE SELECTION DIALOG -->
          <dialog-template-selection
            v-model="showTemplateSelection"
            :templateVar="showTemplateSelectionArray"
            :desc="desc"
            @update:desc="desc = $event"
            @selectedId="changeTemplate($event)"
          ></dialog-template-selection>

          <!-- PLEASE WAIT DIALOG -->
          <v-dialog
            v-model="dialogWait"
            persistent
            max-width="400"
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-card-title class="headline">{{
                $t("userNewOrderPleaseWaitTitle")
              }}</v-card-title>
              <v-card-text class="d-flex">
                <v-spacer></v-spacer>
                <v-progress-linear
                  color="primary"
                  height="10"
                  indeterminate
                ></v-progress-linear>
                <v-spacer></v-spacer>
              </v-card-text>
            </v-card>
          </v-dialog>

          <!-- confirm cancel order dialog -->
          <dialog-basic-yes-no
            :active="showGoBack"
            @clickYes="$router.push('/')"
            @clickNo="showGoBack = false"
            icon="mdi-comment-question-outline"
            :title="$t('msgConfirm')"
            >{{ $t("userNewOrderBasicGoBack2") }}</dialog-basic-yes-no
          >

          <!-- GUMB NAZAJ -->
          <simple-navigation-button
            left
            v-if="e1 <= 3"
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="stepItDown()"
          ></simple-navigation-button>

          <v-snackbar
            v-model="$store.state.storeSnackbar.snackbar.active"
            :color="$store.state.storeSnackbar.snackbar.color"
            :timeout="$store.state.storeSnackbar.snackbar.timeout"
            >{{ $store.state.storeSnackbar.snackbar.message }}</v-snackbar
          >
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";
import "firebase/functions";
import * as c from "@/constants";
import MainSubPageToolbar from "@/components/MainSubPageToolbar";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";
import DialogTemplateSelection from "@/components/DialogTemplateSelection";
import DialogBasicYesNo from "@/components/DialogBasicYesNo";

export default {
  name: "userNewPhotoGiftOrder",
  components: {
    MainSubPageToolbar,
    SimpleNavigationButton,
    DialogTemplateSelection,
    DialogBasicYesNo,
  },
  data() {
    return {
      dialogWait: false,
      e1: 1, // števec za v-stepper
      currentTag: "",
      currentPage: 1,
      currentPages: 1,
      currentPageSize: c.G_TEMPLATE_SELECTION_PAGE_SIZE,
      desc: false,
      subCategorys: [],
      itemTypeSelectOptions: [],
      itemType: "",
      itemCopiesSelectOptions: c.G_COPIES_SELECT_OPTIONS,
      itemCopies: 0,
      itemCategory: "",
      itemMainCategoryId: "",
      itemSubCategory: "",
      itemName: "",
      sendExtraEmailOnOrder: "",
      allowTemplateClones: false,
      allowCustomSize: false,
      superType: 1, // default foto izdelek
      minTemplateClones: 0,
      maxTemplateClones: 0,
      enableDeviceBasedEdit: false,
      itemPrice: 0,
      itemId: "",
      itemFullPrice: 0,
      itemsAvailable: false,
      simpleType: true,
      selectedRoute: "",
      count: 0,
      files: [],
      canvasTemplates: [], // prebrane nastavitve za predlogo
      canvas: [],
      showGoBack: false,
      showTemplateSelection: false,
      dType: "",
      showItemTypeSelection: false,
      showTemplateSelectionMode: 0,
      showTemplateSelectionIndex: 0,
      showTemplateSelectionArray: [],
      showItemTypeSelectionArray: [],
      overrideSize: false,
      overrideSizeWidth: 0,
      overrideSizeHeight: 0,
      selectedTypeArray: "",
      validTo: 0, // za darilne bone
      skipEdit: false, // za darilne bone
    };
  },
  computed: {
    printStepperStepTitle() {
      switch (this.e1) {
        case 1:
          return (
            "(" + this.$t("settingsPhotoGiftCategoryStepperStep1Title") + ")"
          );
        case 2:
          return (
            "(" + this.$t("settingsPhotoGiftCategoryStepperStep2Title") + ")"
          );
        case 3:
          return (
            "(" + this.$t("settingsPhotoGiftCategoryStepperStep3Title") + ")"
          );
        default:
          return "";
      }
    },
  },
  methods: {
    ...mapMutations([
      "SET_CANVAS_TEMPLATES",
      "SET_ITEM_CATEGORY",
      "SET_ITEM_SUPER_CATEGORY_ID",
      "SET_ITEM_MAIN_CATEGORY_ID",
      "SET_ITEM_SUB_CATEGORY",
      "SET_SIMPLE_TYPE",
      "SET_ITEM_TYPE_SELECT_OPTIONS",
      "SET_ITEM_TYPE",
      "SET_ITEM_COPIES",
      "SET_ITEM_COPIES_SELECT_OPTIONS",
      "SET_ITEM_PRICE",
      "SET_ITEM_FULL_PRICE",
      "SET_SELECTED_TYPE_ARRAY",
      "SET_SHOW_ITEM_TYPE_SELECTION_ARRAY",
      "SET_OVERRIDE_SIZE",
      "SET_OVERRIDE_SIZE_WIDTH",
      "SET_OVERRIDE_SIZE_HEIGHT",
      "SET_ITEM_ID",
      "SET_ITEM_NAME",
      "SET_SEND_EXTRA_EMAIL_ON_ORDER",
      "SET_ALLOW_TEMPLATE_CLONES",
      "SET_ALLOW_CUSTOM_SIZE",
      "SET_SUPER_TYPE",
      "SET_MIN_TEMPLATE_CLONES",
      "SET_MAX_TEMPLATE_CLONES",
      "SET_ENABLE_DEVICE_BASED_EDIT",
      "SET_SHOW_PRICE",
      "SET_VALID_TO",
      "SET_SKIP_EDIT",
      "SET_GIFT_INVENTORY",
    ]),
    checkSmallDevicesLimitation(item) {
      if (
        item.enableSmallDevices == false &&
        (this.$store.state.os == "iOS" || this.$store.state.os == "Android") &&
        this.$store.state.storeClient.client.basicSettings.name != "demo"
      ) {
        this.$store.commit({
          type: "showSnackbar",
          color: "warning",
          message: this.$t("warningEnableSmallDevices"),
        });
      } else {
        this.stepItUp(item);
      }
    },
    getPrices(typeArray) {
      // izračunamo price range
      let temp = [];
      typeArray.forEach((y) => {
        if (temp.indexOf(y.price) === -1) temp.push(y.price);
      });
      temp.sort();
      if (temp.length == 1) {
        return this.price(temp[0]);
      } else
        return this.price(temp[0]) + "-" + this.price(temp[temp.length - 1]);
    },
    serveTemplateSelection(i, index) {
      this.showTemplateSelectionMode = i;
      this.showTemplateSelectionIndex = index;
      this.showTemplateSelection = true;

      if (i == 1 && this.canvasTemplates.length == 1) {
        this.showTemplateSelectionArray =
          this.$store.state.storeImageTemplate.imageFilteredTemplate;
      } else {
        this.showTemplateSelectionArray =
          this.$store.state.storeImageTemplate.imageMultipleCanvasFilteredTemplate[
            index
          ];
      }
    },
    loadItemDesign() {
      this.$store.state.storePhotoGiftOrderDesign.multipleCopies = [];
      this.SET_CANVAS_TEMPLATES(this.canvasTemplates);
      this.SET_ITEM_CATEGORY(this.itemCategory);
      this.SET_ITEM_MAIN_CATEGORY_ID(this.itemMainCategoryId);
      this.SET_ITEM_SUB_CATEGORY(this.itemSubCategory);
      this.SET_SIMPLE_TYPE(this.simpleType);
      this.SET_ITEM_TYPE_SELECT_OPTIONS(this.itemTypeSelectOptions);
      this.SET_ITEM_TYPE(this.itemType);
      this.SET_ITEM_ID(this.itemId);
      this.SET_ITEM_COPIES(this.itemCopies);
      this.SET_ITEM_COPIES_SELECT_OPTIONS(this.itemCopiesSelectOptions);
      this.SET_ITEM_PRICE(this.itemPrice);
      this.SET_ITEM_FULL_PRICE(this.itemFullPrice);
      this.SET_SELECTED_TYPE_ARRAY(this.selectedTypeArray);
      this.SET_SHOW_ITEM_TYPE_SELECTION_ARRAY(this.showItemTypeSelectionArray);
      this.SET_OVERRIDE_SIZE(this.overrideSize);
      this.SET_OVERRIDE_SIZE_WIDTH(this.overrideSizeWidth);
      this.SET_OVERRIDE_SIZE_HEIGHT(this.overrideSizeHeight);
      this.SET_ITEM_NAME(this.itemName);
      this.SET_SEND_EXTRA_EMAIL_ON_ORDER(this.sendExtraEmailOnOrder);
      this.SET_ALLOW_TEMPLATE_CLONES(this.allowTemplateClones);
      this.SET_ALLOW_CUSTOM_SIZE(this.allowCustomSize);
      this.SET_SUPER_TYPE(this.superType);
      this.SET_MIN_TEMPLATE_CLONES(this.minTemplateClones);
      this.SET_MAX_TEMPLATE_CLONES(this.maxTemplateClones);
      this.SET_ENABLE_DEVICE_BASED_EDIT(this.enableDeviceBasedEdit);
      this.SET_VALID_TO(this.validTo);
      this.SET_SKIP_EDIT(this.skipEdit);

      this.$router.push({
        path: "/userNewPhotoGiftOrderDesign",
      });
    },
    async changeTemplate(id) {
      console.log("id", id);
      console.log("showTemplateSelectionMode", this.showTemplateSelectionMode);
      if (this.showTemplateSelectionMode == 1) {
        this.canvasTemplates[this.showTemplateSelectionIndex].canvas.dispose();
        this.canvasTemplates[this.showTemplateSelectionIndex].selected =
          this.showTemplateSelectionArray.filter((x) => x.id == id)[0];
        this.canvasTemplates[this.showTemplateSelectionIndex].files = [];

        //await this.prepareSingleCanvas(this.showTemplateSelectionIndex);
      } else if (this.showTemplateSelectionMode == 2) {
        // handle reload current canvas
        this.canvasTemplates[this.showTemplateSelectionIndex].canvas.dispose();
        //await this.prepareSingleCanvas(this.showTemplateSelectionIndex);
      } else {
        this.canvasTemplates[this.showTemplateSelectionIndex].selected =
          this.showTemplateSelectionArray.filter((x) => x.id == id)[0];
        this.canvasTemplates[this.showTemplateSelectionIndex].files = [];
        this.canvasTemplates[this.showTemplateSelectionIndex].filesFrames = [];

        let full = true;
        this.canvasTemplates.map((x) => {
          if (Object.keys(x.selected).length == 0) full = false;
        });
        if (full) {
          this.loadItemDesign();
        }
      }
      this.showTemplateSelection = false;
    },
    async stepItUp(cat) {
      this.desc = false;

      if (this.e1 == 1) {
        /*********************** */
        /* IZBOR KATEGORIJE MENU */
        /*********************** */
        this.dialogWait = true;

        await this.$store.dispatch("getGiftCat", {
          client: this.$store.state.storeClient.client.basicSettings.name,
          name: cat.name,
        });
        this.itemCategory = cat.name;
        this.itemMainCategoryId = cat.id;
        this.e1++;

        // če imamo samo en izdelek, ga avtomatsko izberemo
        if (this.$store.state.storeGift.giftCat.length == 1) {
          console.log(this.$store.state.storeGift.giftCat);
          this.stepItUp(this.$store.state.storeGift.giftCat[0]);
        }

        console.log("getGiftCat => DONE");
        this.dialogWait = false;
      } else if (this.e1 == 2) {
        /******************** */
        /* IZBOR IZDELKA MENU */
        /******************** */
        this.dialogWait = true;

        // preberemo printSize in zgradimo array z objekti nastavitev
        this.itemsAvailable = false;
        this.canvasTemplates = [];
        this.itemSubCategory = cat.name;
        this.selectedRoute = "";
        this.itemId = cat.id;
        this.sendExtraEmailOnOrder = cat.sendExtraEmailOnOrder;
        this.allowTemplateClones = cat.allowTemplateClones;
        this.allowCustomSize = cat.allowCustomSize;
        this.superType = cat.superType;
        this.overrideSize = cat.overrideSize;
        this.overrideSizeWidth = cat.overrideSizeWidth;
        this.overrideSizeHeight = cat.overrideSizeHeight;
        this.minTemplateClones = cat.minTemplateClones;
        this.maxTemplateClones = cat.maxTemplateClones;
        this.enableDeviceBasedEdit = cat.enableDeviceBasedEdit;
        this.validTo = cat.validTo;
        this.skipEdit = cat.skipEdit;

        Array.from(cat.printSizeArray).forEach((x) => {
          this.canvasTemplates.push({
            id: "", // id placeholder
            order: x.order,
            title:
              !x.title || x.title.length == 0
                ? this.$t("settingsPhotoGiftDefaultTemplateTitle")
                : x.title,
            code: x.codes.split("|"),
            image: x.image,
            imageAspectRatio: !x.imageAspectRatio ? 0 : x.imageAspectRatio,
            imageWidth: x.imageWidth,
            imageHeight: x.imageHeight,
            canvas: [],
            files: [],
            filesFrames: [],
            finalPreview: !x.image || x.image.length == 0 ? false : true, // ali imamo sliko za finalni predogled?
            codesArray: x.codesArray,
          });
        });

        this.itemName = cat.name;
        this.itemCopiesSelectOptions = this.itemCopiesSelectOptions.filter(
          (x) => x >= cat.minOrder
        ); // nastavimo minimalni order

        if ("typeArray" in cat && cat.typeArray.length > 0) {
          this.simpleType = false;
        } else this.simpleType = true;

        if (this.simpleType) {
          this.itemFullPrice = 0;
          this.itemPrice = cat.price;
          this.itemTypeSelectOptions = cat.type.split("|");
        } else {
          this.itemFullPrice = 0;
          this.itemPrice = 0;

          cat.typeArray.forEach((y) => {
            let arr = this.$store.state.storePromoCode.activePromoCodes.filter(
              (x) =>
                x.module == c.G_MODULE_PHOTO_GIFT &&
                !x.hidden &&
                x.item == y.recordId &&
                x.subItem == y.id
            );
            if (arr.length > 0) {
              this.showItemTypeSelectionArray.push(
                Object.assign(y, {
                  discount: arr[0].discount,
                  discountType: arr[0].discountType,
                  promoCode: arr[0].promoCode,
                })
              );
              console.log("FOUND");
            } else {
              this.showItemTypeSelectionArray.push(y);
              console.log("NOT FOUND");
            }
          });

          this.selectedTypeArray = "";
          console.log("typeArray", this.showItemTypeSelectionArray);
        }

        this.itemType = "";
        this.itemCopies = 0;

        if (this.canvasTemplates.length == 1) {
          // ČE IMAMO SAMO EN CANVAS

          // IZBOR PREDLOGE
          await this.$store.dispatch("getFilteredImageTemplate", {
            client: this.$store.state.storeClient.client.basicSettings.name,
            module: c.G_MODULE_PHOTO_GIFT,
            private: true,
            code: this.canvasTemplates[0].code,
            storeFiltered: false,
          });
          // kopija začetnih templateov, da lahko resetiramo tag filter
          this.$store.state.storeImageTemplate.tempStartTemplateItemsArray =
            this.$store.state.storeImageTemplate.imageFilteredTemplate;

          this.subCategorys = [];
          this.$store.state.storeImageTemplate.imageFilteredTemplate.forEach(
            (x) => {
              if (
                x.keywords != "" &&
                this.subCategorys.indexOf(x.keywords) === -1
              )
                this.subCategorys.push(x.keywords);
            }
          );
          this.subCategorys.sort();
          this.currentPage = 1;
          this.getTemplatePages(0);

          if (
            this.$store.state.storeImageTemplate.imageFilteredTemplate.length ==
            1
          ) {
            console.log("ONE CANVAS, ONE TEMPLATE = > GO");
            // EN CANVAS IN ENA PREDLOGA
            this.canvasTemplates[0].selected =
              this.$store.state.storeImageTemplate.imageFilteredTemplate[0];
            this.loadItemDesign();
          } else if (
            this.$store.state.storeImageTemplate.imageFilteredTemplate.length >
            1
          ) {
            // EN CANVAS IN VEČ PREDLOG
            this.selectedRoute = "ONE-CANVAS-MULTIPLE-TEMPLATES";
            this.e1++;
            this.dialogWait = false;
          }
        } else if (this.canvasTemplates.length > 1) {
          // ČE IMAMO VEČ CANVASOV
          this.$store.state.storeImageTemplate.imageMultipleCanvasFilteredTemplate =
            [];

          let isOnlyOne = true;
          await Promise.all(
            this.canvasTemplates.map(async (x) => {
              try {
                x.selected = {}; // nastavimo prazno za začetek
                // v imageMultipleCanvasFilteredTemplate se doda v storeImageTemplate.js
                await this.$store.dispatch("getFilteredImageTemplate", {
                  client:
                    this.$store.state.storeClient.client.basicSettings.name,
                  module: c.G_MODULE_PHOTO_GIFT,
                  private: true,
                  code: x.code,
                  storeFiltered: true,
                });

                if (
                  this.$store.state.storeImageTemplate.imageFilteredTemplate
                    .length > 1
                ) {
                  isOnlyOne = false; // pregled ali imajo vsi canvasi le en template
                }
              } catch (error) {
                console.log("error" + error);
              }
            })
          );

          if (isOnlyOne) {
            // ČE IMAMO VEČ CANVASOV IN IMA VSAK LE EN TEMPLATE
            this.count = 0;
            this.canvasTemplates.forEach((x) => {
              x.selected =
                this.$store.state.storeImageTemplate.imageMultipleCanvasFilteredTemplate[
                  this.count
                ][0];
              this.count++;
            });
            this.loadItemDesign();
            console.log("MULTI CANVAS, ONE TEMPLATE => DONE");
          } else {
            // ČE IMAMO VEČ CANVASOV IN VSAJ EDEN IMA VEČ TEMPLATOV
            this.selectedRoute = "MULTIPLE-CANVAS-MULTIPLE-TEMPLATES";

            this.count = 0;
            this.canvasTemplates.forEach((x) => {
              x.selected =
                this.$store.state.storeImageTemplate
                  .imageMultipleCanvasFilteredTemplate[this.count].length == 1
                  ? this.$store.state.storeImageTemplate
                      .imageMultipleCanvasFilteredTemplate[this.count][0]
                  : {};
              this.count++;
            });
            //console.log(this.canvasTemplates);
            this.dialogWait = false;
            this.e1++;
          }
        }
        console.log("getGift => DONE");
      } else if (this.e1 == 3) {
        /********************* */
        /* IZBOR PREDLOGE MENU */
        /********************* */
        if (this.selectedRoute == "ONE-CANVAS-MULTIPLE-TEMPLATES") {
          this.canvasTemplates[0].selected =
            this.$store.state.storeImageTemplate.imageFilteredTemplate.filter(
              (x) => x.id == cat.id
            )[0];
          this.loadItemDesign();
        } else if (this.selectedRoute == "MULTIPLE-CANVAS-MULTIPLE-TEMPLATES") {
          //this.e1++;
          console.log("MULTIPLE-CANVAS-MULTIPLE-TEMPLATES done");
        }
      }
      console.log("stepItUp => DONE");
    },
    stepItDown() {
      if (this.e1 == 1) {
        this.$router.push({ name: "home" });
      } else if (this.e1 == 2) {
        this.e1--;
      } else if (this.e1 == 3) {
        this.e1--;
      }
    },
    getSubcategory(i) {
      this.currentTag = i;
      this.currentPage = 1;
      this.getTemplatePages(0);
    },
    getTemplatePages(i) {
      this.currentPage += i;
      let item = (this.currentPage - 1) * this.currentPageSize;

      if (this.currentTag == "") {
        this.currentPages = Math.ceil(
          this.$store.state.storeImageTemplate.tempStartTemplateItemsArray
            .length / this.currentPageSize
        );

        this.$store.state.storeImageTemplate.imageFilteredTemplate =
          this.$store.state.storeImageTemplate.tempStartTemplateItemsArray.slice(
            0, // ali "item" za pages
            item + this.currentPageSize
          );
      } else {
        this.$store.state.storeImageTemplate.imageFilteredTemplate =
          this.$store.state.storeImageTemplate.tempStartTemplateItemsArray.filter(
            (x) => {
              console.log(x.keywords);
              return x.keywords == this.currentTag;
            }
          );

        this.currentPages = Math.ceil(
          this.$store.state.storeImageTemplate.imageFilteredTemplate.length /
            this.currentPageSize
        );

        this.$store.state.storeImageTemplate.imageFilteredTemplate =
          this.$store.state.storeImageTemplate.imageFilteredTemplate.slice(
            0, // ali "item" za pages
            item + this.currentPageSize
          );

        console.log(
          " => Page " + this.currentPage + " of " + this.currentPages
        );
      }
    },
  },
  async created() {
    await this.$store.dispatch("getGiftCategory", {
      client: this.$store.state.storeClient.client.basicSettings.name,
      superCategory: this.$route.params.subPath,
      mode: "live",
    });
    // če imamo samo eno kategorijo, jo avtomatsko izberemo
    if (this.$store.state.storeGiftCategory.giftCategory.length == 1) {
      this.stepItUp(this.$store.state.storeGiftCategory.giftCategory[0]);
    }
  },
};
</script>
<style>
@import "../../mixins/fonts/loadFonts.css";
.v-stepper::before {
  box-shadow: none;
}
.hover-item {
  cursor: pointer;
}
.img-container {
  /* Never limit the container height here */
  max-width: 100%;
}
.img-container img {
  /* This is important */
  width: 100%;
}
/* edina opcija da spremenim prepend-icon barvo? */
/*.mdi-image-plus::before {
  color: #25832c;
}*/
</style>